module.exports = __webpack_public_path__ + "portal-logo.6548586b9d4de4130853befc8540e5e3.svg";